module.exports = __webpack_public_path__ + "static/media/yoga_banner.3e38b71c.jpg";